if (!customElements.get('variant-panels')) {
  customElements.define(
    'variant-panels',
    class VariantPanels extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('[data-variant-panels-select]');
        this.panels = this.querySelectorAll('[data-variant-panel]');
        if (!this.select || !this.panels.length) return;

        const sectionId = this.getAttribute('data-section');
        this.variantSelector =
          document.querySelector(`variant-radios[data-section="${sectionId}"]`) ||
          document.querySelector(`variant-selects[data-section="${sectionId}"]`);

        this.select.addEventListener('change', () => {
          this.showVariant(this.select.value);
          this.selectProductVariant(this.select.value);
        });

        this.syncWithVariantSelector();
      }

      showVariant(variantId) {
        const id = String(variantId);
        let matched = false;

        this.panels.forEach((panel) => {
          const isMatch = panel.getAttribute('data-variant-panel') === id;
          panel.hidden = !isMatch;
          if (isMatch) matched = true;
        });

        if (matched && this.select.value !== id) {
          this.select.value = id;
        }
      }

      getVariantData() {
        if (!this.variantData) {
          const json = this.variantSelector.querySelector('[type="application/json"]');
          this.variantData = json ? JSON.parse(json.textContent) : [];
        }
        return this.variantData;
      }

      // Applies the panel selection to the main picker so the theme's own change
      // handler updates price, media, URL and the form's variant input.
      selectProductVariant(variantId) {
        if (!this.variantSelector) return;

        const variant = this.getVariantData().find(
          (item) => String(item.id) === String(variantId)
        );
        if (!variant) return;

        const fieldsets = this.variantSelector.querySelectorAll('fieldset');
        if (fieldsets.length) {
          fieldsets.forEach((fieldset, index) => {
            const radio = Array.from(fieldset.querySelectorAll('input[type="radio"]')).find(
              (input) => input.value === variant.options[index]
            );
            if (radio) radio.checked = true;
          });
        } else {
          this.variantSelector.querySelectorAll('select').forEach((select, index) => {
            select.value = variant.options[index];
          });
        }

        this.variantSelector.dispatchEvent(new Event('change', { bubbles: true }));
      }

      syncWithVariantSelector() {
        if (!this.variantSelector) return;

        const form = document.getElementById(this.getAttribute('data-product-form-id'));
        const variantInput = form ? form.querySelector('input[name="id"]') : null;
        if (!variantInput) return;

        this.variantSelector.addEventListener('change', () => {
          window.requestAnimationFrame(() => {
            if (variantInput.value) this.showVariant(variantInput.value);
          });
        });
      }
    }
  );
}
